import SimpleNewsListing from './SimpleNewsListing';
import './SimpleNewsListing.scss';

export default SimpleNewsListing;
